import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import SweetAlert from 'react-bootstrap-sweetalert';
import { defaultDiacriticsRemovalMap } from '../../helpers/ascii_helper';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import filterFactory from 'react-bootstrap-table2-filter';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Card, CardBody, Col, Container, Row, Modal, Button, ModalHeader, ModalBody, FormGroup, Alert, Label } from 'reactstrap';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import PageLoader from '../../components/Loaders/pageLoader';
import BtnLoader from '../../components/Loaders/btnLoader';
import XLSX from 'xlsx';
import danger from '../../assets/images/danger.png';
import InputMask from 'react-input-mask';
import { showToast, showToastFixed } from '../../components/Toast';
import toastr from 'toastr';
//PDF
import { getTransfersShipping, getCompletedTransfers, updateTransferMoscowData, deleteTransferShipping } from '../../store/transfers/actions';
// import { getScreenHeight } from '../../helpers/screen_height_helper';
//Import Breadcrumb
import MyExportCSV from '../../components/exportCSV';
import Breadcrumbs from '../../components/Breadcrumb';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { History, BadgeAlert, CircleCheckBig, Trash2, CircleArrowLeft, Pencil, FileDown, Mail, MailOpen, Check } from 'lucide-react';
import ExcelJS from 'exceljs';
import { sendEmailWithExcel } from '../../api/sendEmailExcel';
import Jerry from '../../assets/images/jerry.jpg';
class TransferShippingList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transfers_shipping: [],
      completed_transfers: [],
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toLocaleDateString('en-GB'),
      endDate: new Date().toLocaleDateString('en-GB'),
      modalAssignBox: false,
      selectedInvoiceNo: '',
      nomenclatureCode0: '',
      my_filtered_transfer_msc: [],
      selectedRows: [],
      // invoiceTest: [],
      error: '',
      loading: false,
      testValue: '',
      displayHidden: false,
      selectedNomenclatureCode: '', // new state variable
      newInputFields: [],
      progress: { step: 'Completed', time: 100 },
      alert: null,
      TransferShippingListColumns: [
        // {
        //   text: 'ID',
        //   dataField: '_id',
        //   sort: true,
        //   editable: false,
        //   csvExport: false,
        //   formatter: (cell, row, rowIndex) => rowIndex + 1
        // },
        {
          text: 'Date',
          dataField: 'date',
          sort: true,
          csvExport: true,
          editable: false,
          hidden: false,
          // editable: true,
          formatter: (cell, transfers_shipping) => {
            if (transfers_shipping.date !== null) {
              let dateObj = transfers_shipping.date;
              if (typeof cell !== 'object') {
                dateObj = new Date(cell);
              }
              return dateObj && `${('0' + dateObj.getDate()).slice(-2)}/${('0' + (dateObj.getMonth() + 1)).slice(-2)}/${dateObj.getFullYear()}`;
            } else {
              return '';
            }
          },
          editor: {
            type: Type.DATE
          }
        },

        {
          text: 'Client Name',
          dataField: 'clientName',
          editable: false,
          formatter: (cellContent, transfers_shipping) => <h5 className='font-size-16 mb-1 text-center'>{transfers_shipping.clientName}</h5>
        },
        {
          text: 'Order',
          dataField: 'orderNumber',
          editable: false,
          formatter: (cellContent, transfers_shipping) => <h5 className='font-size-16 mb-1 text-center'>{transfers_shipping.orderNumber}</h5>
        },
        {
          text: 'Realization',
          dataField: 'realizationNo',
          editable: false,
          formatter: (cellContent, transfers_shipping) => <h5 className='font-size-16 mb-1 text-center'>{transfers_shipping.realizationNo}</h5>
        },
        {
          text: 'Details',
          dataField: 'nomenclature',
          editable: false,
          formatter: (cellContent, transfers_shipping) => {
            const results = [];

            const boxNoAggregated = {};
            transfers_shipping.boxNo.forEach((box) => {
              const nomenclatureCode = box.nomenclatureCode;
              const quantity = parseInt(box.quantity, 10);

              if (!boxNoAggregated[nomenclatureCode]) {
                boxNoAggregated[nomenclatureCode] = 0;
              }

              boxNoAggregated[nomenclatureCode] += quantity;
            });

            // Step 2: Compare aggregated quantities with selectedBoxs
            Object.keys(boxNoAggregated).forEach((nomenclatureCode) => {
              // Find all selectedBoxs with the same nomenclatureCode
              const selectedBoxesWithCode = transfers_shipping.selectedBoxs ? transfers_shipping.selectedBoxs.filter((selectedBox) => selectedBox.nomenclatureCode === nomenclatureCode) : [];

              // Sum the selectedBoxs quantities for that nomenclatureCode
              const totalSelectedQuantity = selectedBoxesWithCode.reduce((sum, selectedBox) => sum + parseInt(selectedBox.quantity, 10), 0);

              // Compare aggregated boxNo quantity with summed selectedBoxs quantity
              const boxQuantity = boxNoAggregated[nomenclatureCode];
              const comparisonResult = boxQuantity === totalSelectedQuantity ? 'MATCH' : totalSelectedQuantity > boxQuantity ? 'EXCEEDS' : 'MISMATCH';

              // Assign the result to each box in boxNo that has this nomenclatureCode
              transfers_shipping.boxNo.forEach((box) => {
                if (box.nomenclatureCode === nomenclatureCode) {
                  box.comparisonResult = comparisonResult;
                }
              });
            });
            // transfers_shipping.boxNo.forEach((box) => {
            //   const nomenclatureCode = box.nomenclatureCode;

            //   // Check if the same nomenclatureCode exists in selectedBoxs
            //   const selectedBoxesWithCode = transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.filter((selectedBox) => selectedBox.nomenclatureCode === nomenclatureCode);

            //   // If found, sum the quantities in selectedBoxs for that nomenclatureCode
            //   if (selectedBoxesWithCode && selectedBoxesWithCode.length > 0) {
            //     const totalSelectedQuantity = selectedBoxesWithCode.reduce((sum, selectedBox) => sum + parseInt(selectedBox.quantity, 10), 0);

            //     // Compare boxNo.quantity and summed selectedBoxs quantity
            //     const boxQuantity = parseInt(box.quantity, 10);
            //     const comparisonResult = boxQuantity === totalSelectedQuantity ? 'MATCH' : totalSelectedQuantity > boxQuantity ? 'EXCEEDS' : 'MISMATCH';

            //     box.comparisonResult = comparisonResult;
            //   }
            // });
            return (
              <div>
                <ul className='custom-list-bullets'>
                  {transfers_shipping.boxNo.map((row, index) => (
                    <li className='font-size-16 list-style-type' key={index}>
                      <div className='d-flex'>
                        <h3
                          style={{
                            textDecoration: row.comparisonResult === 'MATCH' ? 'line-through' : 'none',
                            textDecorationColor: row.comparisonResult === 'MATCH' ? 'red' : 'inherit',
                            textDecorationThickness: row.comparisonResult === 'MATCH' ? '2px' : 'initial'
                          }}
                        >
                          {row.nomenclature}&nbsp;&nbsp;&nbsp;&nbsp;QTY: <b>{row.quantity}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          {row.comparisonResult === 'EXCEEDS' && (
                            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', verticalAlign: 'middle' }}>
                              <BadgeAlert color='red' size={20} style={{ marginRight: '8px' }} />
                              <b>Added more than needed!</b>
                            </span>
                          )}
                        </h3>
                        {row.serialNoFound === false && (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={danger} alt='' width={48} height={48} />
                            <b style={{ marginLeft: '8px' }}>Serial Number Not Found</b>
                          </div>
                        )}
                      </div>

                      <p className='mb-4'>
                        {row.invoiceNo.split('||').map((inv, idx) => (
                          <React.Fragment key={idx}>
                            <b>{inv}</b> <br /> {row.box.split('||')[idx]} <br />
                            {/* ============================================== */}
                          </React.Fragment>
                        ))}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            );
          }
        },
        {
          text: 'Selected Boxes',
          dataField: 'selectedBoxs',
          editable: false,
          formatter: (cellContent, transfers_shipping) => {
            const aggregatedBoxs =
              transfers_shipping.selectedBoxs &&
              transfers_shipping.selectedBoxs.reduce((acc, box, index) => {
                // Use nomenclatureCode as the key to aggregate items
                const key = box.nomenclatureCode;

                if (!acc[key]) {
                  // Initialize a new entry if it doesn't exist in the accumulator
                  acc[key] = {
                    nomenclature: box.nomenclature,
                    invoice: box.invoice.trim(),
                    box: box.box,
                    quantity: box.quantity,
                    originalIndices: [index] // Store the original index here
                  };
                } else {
                  // Append invoices, boxes, and quantities with '||'
                  acc[key].invoice += ` || ${box.invoice.trim()}`;
                  acc[key].box += ` || ${box.box}`;
                  acc[key].quantity += ` || ${box.quantity}`;
                  acc[key].originalIndices.push(index); // Keep track of the original indices
                }

                return acc;
              }, {});

            // Convert the aggregated object into an array
            const aggregatedArray = aggregatedBoxs && Object.values(aggregatedBoxs);
            // Sort the aggregated array by the `invoice` field in ascending order
            const sortedAggregatedArray =
              aggregatedArray &&
              aggregatedArray.sort((a, b) => {
                // Sort by the first invoice value
                const invoiceA = a.invoice.split('||')[0].trim();
                const invoiceB = b.invoice.split('||')[0].trim();
                return invoiceA.localeCompare(invoiceB);
              });

            return (
              <div>
                <ul className='custom-list-bullets'>
                  {aggregatedArray &&
                    aggregatedArray.map((row, index) => (
                      <li className='font-size-16 list-style-type' key={index}>
                        <h3>{row.nomenclature}</h3>
                        <p className='mb-4'>
                          {row.invoice.split('||').map((inv, idx) => (
                            <React.Fragment key={idx}>
                              <b>{inv}</b> - QTY: <b>{typeof row.quantity === 'string' ? row.quantity.split('||')[idx] : row.quantity}</b> &nbsp;&nbsp;&nbsp;
                              <History onClick={() => this.handleRevertSelectedBox(transfers_shipping, row.originalIndices[idx])} color='#f25621' size={18} style={{ cursor: 'pointer' }} />
                              <br />
                              {typeof row.box === 'string' ? row.box.split('||')[idx] : row.box} <br />
                            </React.Fragment>
                          ))}
                        </p>
                      </li>
                    ))}
                </ul>
              </div>
            );
          }
        },
        {
          text: 'Top Comms',
          dataField: 'topComment',
          sort: true,
          editable: true,
          formatter: (cellContent, transfers_shipping) => <h5 className='font-size-16 mb-1'>{transfers_shipping.topComment}</h5>,
          style: { width: '300px' }
        },
        {
          text: 'Btm Comms',
          dataField: 'btmComment',
          sort: true,
          editable: true,
          formatter: (cellContent, transfers_shipping) => <h5 className='font-size-16 mb-1 text-center'>{transfers_shipping.btmComment}</h5>,
          style: { width: '300px' }
        },
        {
          text: 'Carrier',
          dataField: 'carrier',
          editable: true,
          editor: {
            type: Type.SELECT,
            options: [
              { value: ' ', label: 'Select Carrier' }, // Default placeholder option
              { value: 'ЯНДЕКС-КОЛИЧЕСТВО МЕСТ', label: 'ЯНДЕКС-КОЛИЧЕСТВО МЕСТ' },
              { value: 'СДЕК-КОЛИЧЕСТВО МЕСТ/РАЗМЕР/ВЕС', label: 'СДЕК-КОЛИЧЕСТВО МЕСТ/РАЗМЕР/ВЕС' }
            ]
          },
          formatter: (cellContent, transfers_shipping) => (
            <div className='name-width'>
              <h4 className='font-size-16 mb-1'>
                {transfers_shipping.carrier || 'Select Carrier'} {/* Show placeholder if no value */}
              </h4>
            </div>

            // <div className='form-group'>
            //   <select
            //     className='form-control wh-manager-selection'
            //     value={transfers_shipping.carrier || ''}
            //     name='carrier'
            //     onChange={(e) => this.updateCarrier(e, transfers_shipping, 'update_carrier')}
            //   >
            //     <option value='' className='alert-primary'>
            //       Select carrier
            //     </option>
            //     <option value='yandex' className='alert-primary'>
            //       ЯНДЕКС-КОЛИЧЕСТВО МЕСТ
            //     </option>
            //     <option value='cdek' className='alert-primary'>
            //       СДЕК-КОЛИЧЕСТВО МЕСТ/РАЗМЕР/ВЕС
            //     </option>
            //   </select>
            // </div>
          )
        },
        {
          dataField: 'menu',
          text: 'Action',
          editable: false,
          formatter: (cellContent, transfers_shipping) => (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '24px' }}>
              {!transfers_shipping.completed && (
                <>
                  <Pencil size={32} color='brown' style={{ cursor: 'pointer' }} onClick={(e) => this.handleAssignBox(transfers_shipping)} />
                  <FileDown size={32} style={{ cursor: 'pointer' }} onClick={() => this.handleExportExcel(transfers_shipping)} />

                  {transfers_shipping.emailSent ? (
                    <MailOpen size={32} color='green' style={{ cursor: 'pointer' }} onClick={() => this.handleExportExcel(transfers_shipping, sendEmailWithExcel)} title='Send Email' />
                  ) : (
                    <Mail size={32} color='blue' style={{ cursor: 'pointer' }} onClick={() => this.handleExportExcel(transfers_shipping, sendEmailWithExcel)} />
                  )}
                  <CircleCheckBig
                    size={32}
                    color={transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0 ? 'green' : 'grey'}
                    style={{
                      cursor: transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0 ? 'pointer' : 'not-allowed',
                      opacity: transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0 ? 1 : 0.5,
                      pointerEvents: transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0 ? 'auto' : 'none'
                    }}
                    onClick={() => {
                      if (transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0) {
                        this.handleUpdateStatus(transfers_shipping);
                      }
                    }}
                    title='Update Status'
                  />
                  <Trash2
                    size={32}
                    color='red'
                    style={{
                      cursor: transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0 ? 'not-allowed' : 'pointer',
                      opacity: transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0 ? 0.5 : 1,
                      pointerEvents: transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0 ? 'none' : 'auto'
                    }}
                    onClick={() => {
                      if (!transfers_shipping.selectedBoxs || transfers_shipping.selectedBoxs.length === 0) {
                        this.handleDeleteOrder(transfers_shipping);
                      }
                    }}
                    title='Delete'
                  />
                </>
              )}

              {/* ✅ Show only when completed === true */}
              {transfers_shipping.completed && (
                <CircleArrowLeft size={32} color='blue' style={{ cursor: 'pointer' }} onClick={() => this.handleUpdateStatusNotCompleted(transfers_shipping)} title='Mark as Not Completed' />
              )}
            </div>
          )
        }
      ]
    };
    this.getScreenHeight = this.getScreenHeight.bind(this);
    this.indication = this.indication.bind(this);
    this.removeDiacritics = this.removeDiacritics.bind(this);
    this.handleAssignBox = this.handleAssignBox.bind(this);
    this.toggleNewAssignBoxModal = this.toggleNewAssignBoxModal.bind(this);
    this.addInputField = this.addInputField.bind(this);
    this.handleNewTransferShippingSubmit = this.handleNewTransferShippingSubmit.bind(this);
    this.deleteSelectedBox = this.deleteSelectedBox.bind(this);
    this.handleRevertSelectedBox = this.handleRevertSelectedBox.bind(this);
    this.modalCloseFunc = this.modalCloseFunc.bind(this);
    this.handleUpdateStatus = this.handleUpdateStatus.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
    this.updateStatusNotCompleted = this.updateStatusNotCompleted.bind(this);
    this.handleUpdateStatusNotCompleted = this.handleUpdateStatusNotCompleted.bind(this);
    this.handleFilterDataSubmit = this.handleFilterDataSubmit.bind(this);
    this.resetFilterData = this.resetFilterData.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.handleDeleteOrder = this.handleDeleteOrder.bind(this);
    this.deleteAlert = this.deleteAlert.bind(this);
    this.handleBulkUpdateStatus = this.handleBulkUpdateStatus.bind(this);
    this.handleBulkComplete = this.handleBulkComplete.bind(this);
    this.confirmBulkUpdateStatus = this.confirmBulkUpdateStatus.bind(this);
    this.handleSubmitSingleRow = this.handleSubmitSingleRow.bind(this);
    // this.updateCarrier = this.updateCarrier.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
  }
  componentDidMount() {
    const { onGetTransferShipping } = this.props;
    onGetTransferShipping();

    window.addEventListener('load', this.getScreenHeight);
    window.addEventListener('click', this.getScreenHeight, { once: true });
    window.addEventListener('resize', this.getScreenHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.getScreenHeight);
    window.removeEventListener('click', this.getScreenHeight);
    window.removeEventListener('resize', this.getScreenHeight);
  }

  componentDidUpdate(prevProps, prevState) {
    const { error } = this.props;
    if (error != prevProps.error) {
      this.setState({ error });
    }

    if (prevProps.completed_transfers !== this.props.completed_transfers) {
      this.setState({ completed_transfers: this.props.completed_transfers });
    }
  }

  getScreenHeight = () => {
    if (document.getElementById('card-section') != null) {
      let screenHeight = document.getElementById('card-section').offsetHeight;
      document.querySelector('.react-bootstrap-table').setAttribute('style', 'height: calc(' + screenHeight + 'px - 100px); overflow: auto;');
    }
  };

  toggleNewAssignBoxModal = () => {
    this.setState((prevState) => {
      const isClosing = prevState.modalAssignBox;
      return {
        modalAssignBox: !prevState.modalAssignBox,
        newInputFields: isClosing ? [] : prevState.newInputFields // Reset to an empty array when closing
      };
    });
  };

  handleAssignBox = (transfers_shipping) => {
    this.setState({
      invNo: transfers_shipping,
      nomenclatureCode0: '',
      error: '',
      selectedNomenclatureCode: '' // reset when modal is opened
    });
    this.toggleNewAssignBoxModal();
  };

  afterSaveCell = (oldValue, newValue, row, column, rowId) => {
    const { onUpdateTransferMoscowData } = this.props;
    setTimeout(() => {
      const updatedRow = {
        id: row._id,
        option: 'update_carrier',
        [column.dataField]: newValue
      };
      onUpdateTransferMoscowData(updatedRow);

      const result = this.state.TransferShippingListColumns.map((row_map) => {
        if (row_map.id === rowId) {
          const newRow = { ...row_map };
          newRow[column.dataField] = newValue;
          return newRow;
        }
        return row_map;
      });
      this.setState({ TransferShippingListColumns: result });
      // }
    }, 100);
    return { newValue, async: true };
  };

  handleUpdateStatus = (transfers_shipping) => {
    // Extract unique nomenclatureCodes safely from both arrays
    const boxNoMap = new Map(transfers_shipping.boxNo?.map((box) => [box.nomenclatureCode, box.nomenclature]) || []);

    const selectedBoxMap = new Map(transfers_shipping.selectedBoxs?.map((box) => [box.nomenclatureCode, box.nomenclature]) || []);

    // Extract unique nomenclatureCodes
    const boxNoCodes = new Set(boxNoMap.keys());
    const selectedBoxCodes = new Set(selectedBoxMap.keys());

    // Find missing items with nomenclature names
    const missingInBoxNo = [...selectedBoxCodes]
      .filter((code) => !boxNoCodes.has(code))
      .map((code) => ({
        nomenclatureCode: code,
        nomenclature: selectedBoxMap.get(code) || 'Unknown Product'
      }));

    const missingInSelectedBoxs = [...boxNoCodes]
      .filter((code) => !selectedBoxCodes.has(code))
      .map((code) => ({
        nomenclatureCode: code,
        nomenclature: boxNoMap.get(code) || 'Unknown Product'
      }));

    const quantityMismatch = [];

    boxNoCodes.forEach((code) => {
      if (selectedBoxCodes.has(code)) {
        const boxQty = transfers_shipping.boxNo.filter((item) => item.nomenclatureCode === code).reduce((sum, item) => sum + Number(item.quantity || 0), 0);

        const selectedQty = transfers_shipping.selectedBoxs.filter((item) => item.nomenclatureCode === code).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
        if (boxQty !== selectedQty) {
          quantityMismatch.push({
            nomenclatureCode: code,
            nomenclature: boxNoMap.get(code) || 'Unknown Product',
            expected: boxQty,
            found: selectedQty
          });
        }
      }
    });
    const getAlert = () => (
      <SweetAlert
        showCancel
        confirmBtnText='Yes, make completed!'
        confirmBtnBsStyle='success'
        title='Are you sure?'
        onConfirm={() => this.updateStatus(transfers_shipping)}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        <div style={{ fontSize: '18px', textAlign: 'center' }}>
          <img src={Jerry} alt='Jerry' style={{ width: '400px', marginBottom: '15px' }} />

          <p style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '10px' }}>
            {transfers_shipping.orderNumber} {transfers_shipping.clientName}
          </p>

          {/* Missing products list */}
          {missingInSelectedBoxs.length > 0 && (
            <div>
              <ul style={{ marginTop: '10px', paddingLeft: '0' }}>
                {missingInSelectedBoxs.map((product, index) => (
                  <li
                    key={index}
                    style={{
                      fontSize: '24px',
                      marginBottom: '5px',
                      paddingLeft: '0',
                      color: 'red',
                      fontWeight: 'bold'
                    }}
                  >
                    - {product.nomenclature}
                  </li>
                ))}
              </ul>
              <p style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px' }}>These products are not allocated yet!</p>
            </div>
          )}

          {/* Quantity mismatch list */}
          {quantityMismatch.length > 0 && (
            <div style={{ marginTop: '20px' }}>
              <p style={{ fontSize: '22px', fontWeight: 'bold', color: 'orange' }}>Quantity Mismatch:</p>
              <ul style={{ paddingLeft: '0' }}>
                {quantityMismatch.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      fontSize: '20px',
                      marginBottom: '5px',
                      color: 'orange',
                      fontWeight: 'bold'
                    }}
                  >
                    - {item.nomenclature}: expected {item.expected}, selected {item.found}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Final confirmation */}
          {missingInSelectedBoxs.length === 0 && quantityMismatch.length === 0 && (
            <p style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '20px' }}>Are you sure you want to make it completed?</p>
          )}
        </div>
      </SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };

  handleBulkUpdateStatus = (event, values) => {
    const { action } = values;
    if (action === 'complete') {
      this.handleBulkComplete(); // Run complete-specific logic
    } else {
      // Future actions can go here
      console.warn(`Unhandled action: ${action}`);
    }
  };

  handleBulkComplete = () => {
    const { selectedRows } = this.state;

    const problematicTransfers = [];
    let hasIssues = false;

    selectedRows.forEach((transfer) => {
      const boxNoMap = new Map(transfer.boxNo?.map((box) => [box.nomenclatureCode, box.nomenclature]) || []);
      const selectedBoxMap = new Map(transfer.selectedBoxs?.map((box) => [box.nomenclatureCode, box.nomenclature]) || []);

      const boxNoCodes = new Set(boxNoMap.keys());
      const selectedBoxCodes = new Set(selectedBoxMap.keys());

      const missingInSelectedBoxs = [...boxNoCodes]
        .filter((code) => !selectedBoxCodes.has(code))
        .map((code) => ({
          nomenclatureCode: code,
          nomenclature: boxNoMap.get(code) || 'Unknown Product'
        }));

      const quantityMismatch = [];
      boxNoCodes.forEach((code) => {
        if (selectedBoxCodes.has(code)) {
          const boxQty = transfer.boxNo.filter((item) => item.nomenclatureCode === code).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
          const selectedQty = transfer.selectedBoxs.filter((item) => item.nomenclatureCode === code).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
          if (boxQty !== selectedQty) {
            quantityMismatch.push({
              nomenclatureCode: code,
              nomenclature: boxNoMap.get(code) || 'Unknown Product',
              expected: boxQty,
              found: selectedQty
            });
          }
        }
      });

      if (missingInSelectedBoxs.length > 0 || quantityMismatch.length > 0) {
        hasIssues = true;
      }

      problematicTransfers.push({
        transfer,
        missingInSelectedBoxs,
        quantityMismatch
      });
    });

    const bulkAlert = (
      <SweetAlert
        showCancel
        confirmBtnText='Yes, make completed!'
        confirmBtnBsStyle='success'
        title={hasIssues ? 'Are you sure? Issues detected!' : 'Are you sure?'}
        onConfirm={this.confirmBulkUpdateStatus}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        <div style={{ fontSize: '18px', textAlign: 'center', maxHeight: '700px', overflowY: 'auto' }}>
          <img src={Jerry} alt='Jerry' style={{ width: '400px', marginBottom: '15px' }} />

          {problematicTransfers.map(({ transfer, missingInSelectedBoxs, quantityMismatch }, idx) => (
            <div key={idx} style={{ marginBottom: '30px' }}>
              <p style={{ fontSize: '26px', fontWeight: 'bold', marginBottom: '10px' }}>
                {transfer.orderNumber} {transfer.clientName}
              </p>

              {/* Missing Products */}
              {missingInSelectedBoxs.length > 0 && (
                <div>
                  <ul style={{ marginTop: '10px', paddingLeft: '0' }}>
                    {missingInSelectedBoxs.map((product, i) => (
                      <li
                        key={i}
                        style={{
                          fontSize: '24px',
                          marginBottom: '5px',
                          paddingLeft: '0',
                          color: 'red',
                          fontWeight: 'bold'
                        }}
                      >
                        - {product.nomenclature}
                      </li>
                    ))}
                  </ul>
                  <p style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px' }}>These products are not allocated yet!</p>
                </div>
              )}

              {/* Quantity Mismatch */}
              {quantityMismatch.length > 0 && (
                <div style={{ marginTop: '20px' }}>
                  <p style={{ fontSize: '22px', fontWeight: 'bold', color: 'orange' }}>Quantity Mismatch:</p>
                  <ul style={{ paddingLeft: '0' }}>
                    {quantityMismatch.map((item, i) => (
                      <li
                        key={i}
                        style={{
                          fontSize: '20px',
                          marginBottom: '5px',
                          color: 'orange',
                          fontWeight: 'bold'
                        }}
                      >
                        - {item.nomenclature}: expected {item.expected}, selected {item.found}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Clean confirmation */}
              {missingInSelectedBoxs.length === 0 && quantityMismatch.length === 0 && <p style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '20px' }}>Ready to complete.</p>}
              <hr />
            </div>
          ))}

          <p style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '20px' }}>
            {hasIssues ? 'Some orders have issues. Do you still want to mark all as completed?' : 'All orders are clean. Proceed to complete them?'}
          </p>
        </div>
      </SweetAlert>
    );

    this.setState({ alert: bulkAlert });
  };

  confirmBulkUpdateStatus = () => {
    const { selectedRows } = this.state;
    const { onUpdateTransferMoscowData } = this.props;

    selectedRows.forEach((row) => {
      const itemToUpdate = {
        id: row._id,
        option: 'make_row_completed'
      };
      onUpdateTransferMoscowData(itemToUpdate);
    });

    this.setState({
      selectedRows: [],
      action: '',
      alert: null
    });
  };

  handleUpdateStatusNotCompleted = (transfers_shipping) => {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText='Yes, make uncompleted!'
        confirmBtnBsStyle='success'
        title='Are you sure?'
        onConfirm={() => this.updateStatusNotCompleted(transfers_shipping)}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        The order with Invoice
        <span className='fw-bold'> #{transfers_shipping.orderNumber}</span> will be marked as uncompleted!
      </SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };

  updateStatus = (transfers_shipping) => {
    const { onUpdateTransferMoscowData } = this.props;

    const itemToUpdate = {
      id: transfers_shipping._id,
      option: 'make_row_completed'
    };
    onUpdateTransferMoscowData(itemToUpdate);

    this.hideAlert();
  };

  updateStatusNotCompleted = (transfers_shipping) => {
    const { onUpdateTransferMoscowData } = this.props;

    const itemToUpdate = {
      id: transfers_shipping._id,
      option: 'make_row_not_completed'
    };
    onUpdateTransferMoscowData(itemToUpdate);

    this.hideAlert();
  };

  updateEmailSent = (transfers_shipping) => {
    const { onUpdateTransferMoscowData } = this.props;

    const itemToUpdate = {
      id: transfers_shipping._id,
      option: 'make_email_sent'
    };
    onUpdateTransferMoscowData(itemToUpdate);

    this.hideAlert();
  };

  handleNomenclatureChange = (index, e) => {
    const { value } = e.target;
    const nomenclatureCode = value.split('||')[1];
    const newInputFields = [...this.state.newInputFields];

    // Update nomenclature for the specific row
    newInputFields[index].nomenclature = value;

    // Filter the invoice options based on the selected nomenclature code
    const invoiceOptions = this.state.invNo.boxNo.filter((inv) => inv.nomenclatureCode === nomenclatureCode).flatMap((inv) => inv.invoiceNo.split('||'));

    // Update invoice options for the specific row
    newInputFields[index].invoiceOptions = invoiceOptions;

    // Update state
    this.setState({ newInputFields });
  };

  handleInputChange = (index, field, value) => {
    const newInputFields = [...this.state.newInputFields];
    newInputFields[index][field] = value;
    this.setState({ newInputFields });
  };

  handleDeleteOrder = (transfers_shipping) => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        onConfirm={() => this.deleteAlert(transfers_shipping._id)}
        onCancel={this.hideAlert}
        focusCancelBtn
        style={{ width: '600px', maxWidth: '90%' }} // ✅ Increase modal size
      >
        <div style={{ fontSize: '18px' }}>
          {' '}
          {transfers_shipping.selectedBoxs && transfers_shipping.selectedBoxs.length > 0 ? (
            <div>
              <p style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>
                {transfers_shipping.orderNumber} {transfers_shipping.clientName}
              </p>
              <ul
                style={{
                  marginTop: '10px',
                  paddingLeft: '0'
                }}
              >
                {transfers_shipping.selectedBoxs.map((product, index) => (
                  <li
                    key={index}
                    style={{
                      fontSize: '18px',
                      marginBottom: '5px',
                      paddingLeft: '0'
                    }}
                  >
                    -{product.nomenclature}
                  </li>
                ))}
              </ul>
              <p style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '15px' }}>These products are already allocated in the order!</p>
            </div>
          ) : (
            <p style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this item?</p>
          )}
        </div>
      </SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };

  // updateCarrier = (e, transfers_shipping) => {
  //   const { onUpdateTransferMoscowData } = this.props;
  //   const itemToUpdate = {
  //     id: transfers_shipping._id,
  //     option: 'make_row_not_completed'
  //   };
  //   // onUpdateTransferMoscowData(itemToUpdate);

  //   // this.hideAlert();
  // };

  deleteAlert = (id) => {
    const { onDeleteTransferShipping } = this.props;
    onDeleteTransferShipping(id);
    this.hideAlert();
    // onDeleteTransfer(transfer);
  };

  hideAlert = () => this.setState({ alert: null });

  deleteSelectedBox = (transfers_shipping, aggregatedIndex) => {
    const { onUpdateTransferMoscowData } = this.props;
    const aggregatedItem = transfers_shipping.selectedBoxs[aggregatedIndex];
    const nomenclatureCode = aggregatedItem.nomenclatureCode;
    const invoice = aggregatedItem.invoice;
    const box = aggregatedItem.box;
    const quantity = aggregatedItem.quantity;

    const itemToDelete = {
      nomenclatureCode,
      invoice,
      box,
      quantity,
      option: 'delete_row',
      id: transfers_shipping._id
    };

    // console.info('Item to delete:', itemToDelete);

    onUpdateTransferMoscowData(itemToDelete);
    this.hideAlert();
  };

  handleRevertSelectedBox = (transfer, aggregatedIndex) => {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText='Yes, revert it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteSelectedBox(transfer, aggregatedIndex)}
        onCancel={this.hideAlert}
        focusCancelBtn
      ></SweetAlert>
    );

    this.setState({
      alert: getAlert()
    });
  };

  hideAlert = () => this.setState({ alert: null });

  handleExportExcel = async (transfers_shipping, callback) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');
    const date = new Date(transfers_shipping.date);
    const formattedDate = date.toLocaleDateString('en-GB'); // "20/01/2025"
    let totalQuantity = 0;
    let totalQuantityIce = 0;
    // Your data
    const data = [
      [`ЗАЯВКА НА ОТГРУЗКУ СО СКЛАДА`],
      [`${transfers_shipping.clientName} ${transfers_shipping.orderNumber}-${transfers_shipping.realizationNo}`],
      [`${transfers_shipping.topComment || ''}`],
      [`ИСПОЛНИТЕЛЬ: ООО «СЕЙФКИПИНГ»ИНН/КПП:7703802843/770301001 г.Москва, проезд Серебрякова,д. 14 Г телефон склада 8 (499)707-88-14`],
      ['Заявку составил (Ф.И.О.*): Sim Maksim'],
      ['Данные клиента (водителя,авто)*:', '', `${transfers_shipping.carrier}`],
      ['Дата заявки    ' + formattedDate],
      ['#', 'Nomenclature', 'Order No', 'Box No', 'QTY', 'Ice/Comment', 'SerialNo']
    ];
    for (let i = 0; i < transfers_shipping.boxNo.length; i++) {
      let invNew = transfers_shipping.boxNo[i].invoiceNo.replaceAll('||', '\n====================\n');
      let boxNoNew = transfers_shipping.boxNo[i].box.replaceAll('||', '\n====================\n');
      boxNoNew = boxNoNew.replace(/,/g, ', ');
      const quantity = Number(transfers_shipping.boxNo[i].quantity) || 0; // ✅ Convert to number safely
      totalQuantity += quantity; // ✅ Add quantity to total variable

      const iceComment = transfers_shipping.boxNo[i].ice_comment || '';
      const hasNumber = /\d/.test(iceComment);

      const quantityIce = hasNumber ? Number(iceComment) : 0;
      totalQuantityIce += quantityIce;
      const csvRow = [
        i + 1,
        transfers_shipping.boxNo[i].nomenclature.trim(),
        invNew,
        boxNoNew + ' ',
        transfers_shipping.boxNo[i].quantity,
        hasNumber ? `${iceComment} лед` : iceComment,
        transfers_shipping.boxNo[i].serialNo
      ];
      data.push(csvRow);
      // data.push([
      //   '', // Empty for numbering column
      //   '', // Empty for nomenclature
      //   '', // Empty for invoice
      //   'Total Quantity:', // ✅ Label in Box column (D)
      //   totalQuantity, // ✅ Sum in QTY column (E)
      //   '', // Empty for Ice
      //   '' // Empty for Serial No
      // ]);
    }

    // ✅ Find the last row index dynamically AFTER loop
    // const lastDataRow = data.length + 6; // Because ExcelJS uses 1-based index
    // // ✅ Add SUM formula for column E (Quantity Column)
    // const sumCell = worksheet.getCell(`E11`);
    // sumCell.value = totalQuantity; // SUM from row 7 to last data row
    // sumCell.font = { size: 18, bold: true };
    // sumCell.alignment = { horizontal: 'center', vertical: 'middle' };

    // // ✅ Add "Total Quantity:" label in column D
    // const sumLabelCell = worksheet.getCell(`D${lastDataRow + 1}`);
    // sumLabelCell.value = 'Total Quantity:';
    // sumLabelCell.font = { size: 18, bold: true };
    // sumLabelCell.alignment = { horizontal: 'right', vertical: 'middle' };

    // data.push(
    //   [],
    //   [],
    //   [],
    //   [],
    //   [],
    //   [],
    //   ['* данные заполняет заказчик'],
    //   ['количество строк меняется вручную заказчиком'],
    //   ['ГРУЗ ПРИНЯЛ:', '', '', 'ГРУЗ ОТПУСТИЛ:'],
    //   ['ПРИТЕНЗИЙ К ВНЕШНЕМУ ВИДУ НЕ ИМЕЮ:', '', '', 'ПРИМЕЧАНИЯ']
    // );
    // Add an empty column between the two items in the last row
    // data[data.length - 1].splice(1, 0, '');
    // // Insert an empty row after the fourth row
    data.splice(6, 0, ['']); // Inserts an empty array at index 4

    // Add the data to the worksheet
    data.forEach((row) => {
      worksheet.addRow(row);
    });
    // Merge rows
    worksheet.mergeCells('A1:D1');
    worksheet.mergeCells('A2:D2');
    worksheet.mergeCells('A3:D3');
    // worksheet.mergeCells('B17:G17');
    worksheet.mergeCells('A4:D4');
    worksheet.mergeCells('A5:D5');
    worksheet.mergeCells('A6:B6');
    worksheet.mergeCells('C6:D6');
    worksheet.mergeCells('A7:C7');
    worksheet.mergeCells('A8:C8');

    const lastDataRow = data.length + 1; // Because ExcelJS uses 1-based index
    const lastDataRow1 = data.length + 1; // Because ExcelJS uses 1-based index
    const btmCommentRow = data.length + 3; // Because ExcelJS uses 1-based index
    // ✅ Add SUM formula for column E (Quantity Column)
    const sumCell = worksheet.getCell(`E${lastDataRow}`);
    const sumCellIce = worksheet.getCell(`F${lastDataRow1}`);
    const sumCellBtm = worksheet.getCell(`B${btmCommentRow}`);
    worksheet.mergeCells(`B${btmCommentRow}:G${btmCommentRow}`);

    sumCellBtm.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD9D9D9' } // Light grey color
    };
    worksheet.getRow(btmCommentRow).height = 60;
    sumCell.value = totalQuantity; // SUM from row 7 to last data row
    sumCellIce.value = totalQuantityIce > 0 ? `${totalQuantityIce} лед` : ''; // SUM from row 7 to last data row
    sumCellBtm.value = transfers_shipping.btmComment || ''; // SUM from row 7 to last data row
    // Center the text in the first merged row
    const firstMergedRow = worksheet.getCell('A1');
    firstMergedRow.alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true
    };
    worksheet.getRow(4).height = 40;
    firstMergedRow.font = {
      bold: true,
      size: 12 // Adjust the font size as needed
    };

    // Center the text in the second merged row
    const secondMergedRow = worksheet.getCell('A2');
    secondMergedRow.alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true
    };
    secondMergedRow.font = {
      bold: true,
      size: 18 // Adjust the font size as needed
    };
    const thirdMergedRow = worksheet.getCell('A3');
    thirdMergedRow.alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true
    };
    thirdMergedRow.font = {
      bold: true,
      size: 18 // Adjust the font size as needed
    };
    thirdMergedRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD9D9D9' } // light grey
    };
    // Set the font style for the merged cell (third row)
    const fourthMergedRow = worksheet.getCell('A4');
    fourthMergedRow.font = {
      size: 12
    };
    fourthMergedRow.alignment = {
      horizontal: 'left',
      vertical: 'middle',
      wrapText: true
    };

    // Set the font style for the merged cell (fourth row)
    const fifthMergedRow = worksheet.getCell('A5');
    fifthMergedRow.font = {
      size: 10, // Adjust the font size as needed
      color: { argb: 'FF0000' } // Red font color
    };
    const sixMergedRow = worksheet.getCell('A6');
    sixMergedRow.font = {
      size: 10, // Adjust the font size as needed
      color: { argb: 'FF0000' } // Red font color
    };

    const seventhRow = worksheet.getCell('A7');
    seventhRow.font = {
      size: 14,
      bold: true
    };
    seventhRow.alignment = {
      horizontal: 'left',
      vertical: 'middle',
      wrapText: true
    };

    const carrierRow = worksheet.getCell('C6');
    carrierRow.font = {
      bold: true,
      size: 16,
      color: { argb: 'FF0000' } // Red font color
    };

    const columnE = worksheet.getColumn('F'); // Column E
    columnE.width = 20; // Set initial default width to 20 for better visibility

    // Set minimum and maximum widths for column E
    const minWidth = 20; // Minimum width value
    const maxWidth = 50; // Maximum width value

    // Ensure column width stays within the min and max range
    columnE.width = Math.min(Math.max(columnE.width, minWidth), maxWidth);

    worksheet.getColumn('E').eachCell((cell) => {
      cell.font = {
        size: 18,
        bold: true
      };
      cell.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true
      };
    });
    worksheet.getColumn('F').eachCell((cell) => {
      cell.font = {
        size: 17,
        bold: true
      };
      cell.alignment = {
        horizontal: 'center',
        vertical: 'middle',
        wrapText: true
      };
    });

    worksheet.getColumn('A').width = 4; // Adjust the width as needed
    worksheet.getColumn('B').width = 50; // Adjust the width as needed
    worksheet.getColumn('C').width = 30; // Adjust the width as needed
    worksheet.getColumn('D').width = 30; // Adjust the width as needed
    worksheet.getColumn('E').width = 10; // Adjust the width as needed
    worksheet.getColumn('G').width = 25; // Adjust the width as needed

    // Center text in columns C and D for rows starting from row 6 (index 5)
    for (let rowIndex = 7; rowIndex < data.length; rowIndex++) {
      ['A', 'C', 'D', 'G'].forEach((col) => {
        const cell = worksheet.getCell(`${col}${rowIndex + 1}`);
        cell.alignment = {
          horizontal: 'center',
          vertical: 'middle',
          wrapText: true
        };
        cell.font = {
          size: 14 // Adjust the font size as needed
        };
      });
    }

    for (let rowIndex = 7; rowIndex < data.length; rowIndex++) {
      ['B'].forEach((col) => {
        const cell = worksheet.getCell(`${col}${rowIndex + 1}`);
        cell.alignment = {
          horizontal: 'left',
          vertical: 'middle',
          wrapText: true
        };
        cell.font = {
          size: 14 // Adjust the font size as needed
        };
      });
    }

    // Add borders around the table (skip the first 5 rows)
    for (let rowIndex = 7; rowIndex < data.length; rowIndex++) {
      for (let columnIndex = 0; columnIndex < data[rowIndex].length; columnIndex++) {
        const cell = worksheet.getCell(`${String.fromCharCode(65 + columnIndex)}${rowIndex + 1}`);
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      }
    }

    for (let rowIndex = 9; rowIndex < data.length + 1; rowIndex++) {
      const excelRow = rowIndex + 1;
      const iceCommentCell = worksheet.getCell(`F${excelRow}`);
      const hasValue = iceCommentCell.value && String(iceCommentCell.value).trim() !== '';

      if (hasValue) {
        ['E', 'F'].forEach((col) => {
          const cell = worksheet.getCell(`${col}${excelRow}`);
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFD9D9D9' } // light grey
          };
        });
      }
    }

    sumCellBtm.font = { size: 18, bold: true };
    sumCellBtm.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };

    // worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
    //   if (rowNumber > data.length - 4) {
    //     // Merge columns A (1) and B (2) for this row
    //     worksheet.mergeCells(rowNumber, 1, rowNumber, 2);

    //     const mergedCell = worksheet.getCell(rowNumber, 1);
    //     mergedCell.alignment = {
    //       horizontal: 'center', // Adjust if needed (left, right, center)
    //       vertical: 'middle',
    //       wrapText: true
    //     };
    //     mergedCell.font = { size: 12 };

    //     row.eachCell({ includeEmpty: false }, (cell, colNumber) => {
    //       if (colNumber > 2) {
    //         // Avoid formatting the merged cell twice
    //         cell.font = { size: 12 };
    //         cell.alignment = {
    //           horizontal: 'left',
    //           vertical: 'middle',
    //           wrapText: true
    //         };
    //       }
    //     });
    //   }
    // });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Если передана callback-функция (например, для отправки email)
    if (callback) {
      showToastFixed('Sending Email!');
      try {
        await callback(blob, transfers_shipping.clientName, transfers_shipping.orderNumber, transfers_shipping.carrier, transfers_shipping.realizationNo);
      } finally {
        this.updateEmailSent(transfers_shipping);
        toastr.clear();
        showToast('Email Sent!');
      }
    } else {
      // Локальное скачивание
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `ЗАЯВКА_${transfers_shipping.clientName}_${transfers_shipping.orderNumber}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  indication = () => {
    let emptyMessage = '';
    if (this.props.transfers_shipping.length !== 0) {
      emptyMessage = `No Results Found`;
    }
    return emptyMessage;
  };

  addInputField = () => {
    // Copy the current input fields state
    const newInputFields = [...this.state.newInputFields];

    // Push a new input field state
    newInputFields.push({
      nomenclature: '', // To store the selected nomenclature
      invoiceOptions: [], // To store filtered invoice options
      box: '', // Box value for the current row
      quantity: '',
      submitted: false // Quantity value for the current row
    });

    // Set the new state
    this.setState({ newInputFields });
  };

  removeInputField = (index) => {
    // Copy the current input fields state
    const newInputFields = [...this.state.newInputFields];

    // Remove the input field at the specified index
    newInputFields.splice(index, 1);

    // Update state with modified input fields
    this.setState({ newInputFields });
  };

  removeDiacritics = (str) => {
    let changes = '';
    if (!changes) {
      changes = defaultDiacriticsRemovalMap;
    }
    for (var i = 0; i < changes.length; i++) {
      str = str.replace(changes[i].letters, changes[i].base);
    }
    return str;
  };

  handleSubmitSingleRow = (index) => {
    const row = this.state.newInputFields[index];

    // ✅ Basic validation
    if (!row.nomenclature || !row.invoice || !row.box || !row.quantity) {
      alert('Please complete all fields before submitting this row.');
      return;
    }

    const values = {
      nomenclature: row.nomenclature,
      invoice: row.invoice,
      box: row.box,
      quantity: row.quantity
    };
    const updatedRows = [...this.state.newInputFields];
    updatedRows[index].submitted = true;
    this.setState({ newInputFields: updatedRows });
    this.handleNewTransferShippingSubmit(null, values, null, index);

    setTimeout(() => {
      const { error } = this.state;
      console.log('error', error);
      if (error || (Array.isArray(error) && error.length > 0)) {
        const updatedRows = [...this.state.newInputFields];
        updatedRows[index].submitted = false;
        this.setState({ newInputFields: updatedRows });
      } else {
        // alert('Server rejected this row. Please review and try again.');
        console.warn('Submission error:', error);
      }
    }, 800);
  };

  // handleNewTransferShippingSubmit = async (e, values, error) => {
  //   const { onUpdateTransferMoscowData } = this.props;
  //   // const { error } = this.props;
  //   const output = [];

  //   for (let i = 0; i < Object.keys(values).length / 4; i++) {
  //     const entry = {};
  //     for (let key of ['nomenclature', 'invoice', 'box', 'quantity']) {
  //       entry[`${key}${i}`] = values[`${key}${i}`].split('||')[0];
  //       entry[`nomenclatureCode${i}`] = values[`nomenclature${i}`].split('||')[1];
  //     }
  //     output.push(entry);
  //   }
  //   const outputArray = output.map((item) => {
  //     const entry = {};
  //     Object.keys(item).forEach((key) => {
  //       const field = key.replace(/\d+/g, ''); // Remove numbers from the key
  //       entry[field] = item[key];
  //     });
  //     return entry;
  //   });
  //   outputArray.id = this.state.invNo._id;
  //   await onUpdateTransferMoscowData(outputArray);

  //   // setTimeout(() => {
  //   //   const { error } = this.props; // Get the latest error from Redux

  //   //   if (!error || error === '') {
  //   //     this.setState({
  //   //       modalAssignBox: false,
  //   //       newInputFields: []
  //   //     });
  //   //   }
  //   // }, 500);
  //   // if (!error) {
  //   //   // ✅ Close modal only if no error exists
  //   //   this.setState({
  //   //     modalAssignBox: false,
  //   //     newInputFields: [] // Clear input fields when closing modal
  //   //   });
  //   // }
  //   setTimeout(() => {
  //     this.modalCloseFunc();
  //   }, 1300);
  // };

  handleNewTransferShippingSubmit = async (e, values, error, rowIndex = null) => {
    const { onUpdateTransferMoscowData } = this.props;
    const outputArray = [];

    // 🧠 Mode A: Entire form submission (loop over multiple indexed inputs)
    if (rowIndex === null) {
      const submittedKeys = new Set(
        this.state.newInputFields
          .filter((row) => row.submitted)
          .map((row) => {
            const [_, code] = row.nomenclature.split('||');
            return `${code}-${row.box}-${row.invoice}`;
          })
      );

      const output = [];

      for (let i = 0; i < Object.keys(values).length / 4; i++) {
        const nomenclatureSplit = values[`nomenclature${i}`].split('||');
        const code = nomenclatureSplit[1];
        const box = values[`box${i}`];
        const invoice = values[`invoice${i}`];
        const key = `${code}-${box}-${invoice}`;

        // 🔥 Skip if already submitted
        if (submittedKeys.has(key)) continue;

        const entry = {};
        for (let key of ['nomenclature', 'invoice', 'box', 'quantity']) {
          entry[`${key}${i}`] = values[`${key}${i}`].split('||')[0];
          entry[`nomenclatureCode${i}`] = values[`nomenclature${i}`].split('||')[1];
        }

        output.push(entry);
      }

      // ✅ This is your original transformation step — keep it
      output.forEach((item) => {
        const entry = {};
        Object.keys(item).forEach((key) => {
          const field = key.replace(/\d+/g, '');
          entry[field] = item[key];
        });
        outputArray.push(entry);
      });
    }

    // 🧠 Mode B: Single-row submission (values is a plain object)
    else {
      const nomenclatureSplit = values.nomenclature.split('||');
      const entry = {
        nomenclature: nomenclatureSplit[0],
        nomenclatureCode: nomenclatureSplit[1],
        invoice: values.invoice,
        box: values.box,
        quantity: values.quantity
      };
      outputArray.push(entry);
    }

    // Add ID to payload
    outputArray.id = this.state.invNo._id;
    console.log('outputArray', outputArray);
    // Dispatch data update
    await onUpdateTransferMoscowData(outputArray);

    // Auto-close modal only on full-form submission
    if (rowIndex === null) {
      setTimeout(() => {
        this.modalCloseFunc();
      }, 1300);
    }
  };

  modalCloseFunc = () => {
    const { error } = this.state;
    if (!error) {
      this.setState({
        modalAssignBox: false,
        newInputFields: [] // Clear input fields when closing modal
      });
    }
  };

  handleFilterDataSubmit = (e, values) => {
    const { startDate, endDate } = this.state;
    const { onGetCompletedTransfer, filtered_transfers } = this.props;
    const data = {
      startDate: startDate,
      endDate: endDate,
      status: values.status_type
    };
    onGetCompletedTransfer(data);
    // this.setState((prevState) => ({ filteredTransfers: filtered_transfers }));
  };

  onChangeValue = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  resetFilterData = () => {
    const { onGetTransferShipping } = this.props;
    this.setState({ completed_transfers: [] });
    onGetTransferShipping();
  };

  render() {
    const { SearchBar } = Search;
    const { transfers_shipping, profileData } = this.props;
    const { selectedRows, completed_transfers, invNo, modalAssignBox, error, newState, invoiceTest, startDate, endDate, loading } = this.state;
    const pageOptions = {
      sizePerPage: completed_transfers.length !== 0 ? completed_transfers.length : transfers_shipping.length,
      sizePerPageList: [500, 1000, 1500],
      totalSize: completed_transfers.length !== 0 ? completed_transfers.length : transfers_shipping.length,
      custom: true
    };

    const defaultSorted = [
      {
        dataField: 'date', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];

    const selectRow = {
      mode: 'checkbox',
      selected: selectedRows.map((row) => row._id), // still provide IDs to the table component
      multipleSelectRow: true,

      onSelectAll: (isSelect, rows, e) => {
        if (!isSelect) {
          this.setState({ selectedRows: [] });
        } else {
          this.setState({ selectedRows: [...rows] }); // store full data
        }
      },

      onSelect: (row, isSelect, rowIndex, e) => {
        let updatedSelectedRows = [];

        if (e.shiftKey && this.state.lastSelectedIndex !== null) {
          const currentRowIndex = rowIndex;
          const start = Math.min(this.state.lastSelectedIndex, currentRowIndex);
          const end = Math.max(this.state.lastSelectedIndex, currentRowIndex);
          const tableData = this.props.data || [];

          const selectedInRange = tableData.slice(start, end + 1);

          updatedSelectedRows = [...this.state.selectedRows, ...selectedInRange.filter((r) => !this.state.selectedRows.some((sel) => sel._id === r._id))];
        } else {
          if (isSelect) {
            updatedSelectedRows = [...this.state.selectedRows, row];
          } else {
            updatedSelectedRows = this.state.selectedRows.filter((r) => r._id !== row._id);
          }
        }

        this.setState({
          selectedRows: updatedSelectedRows,
          lastSelectedIndex: rowIndex
        });
      }
    };
    console.log(profileData);
    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {profileData.length !== 0 && loading && <PageLoader progress={this.state.progress} isLoading={loading} />}
        <div className='page-content'>
          <MetaTags>
            <title>Shipping Application #7 Moscow</title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('shipAppwh7Access') ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title='Korupharma' breadcrumbItem='Shipping Application #7 Moscow' />
                <Row id='card-section' onLoad={this.getScreenHeight()}>
                  <Col lg='12'>
                    <Card>
                      <CardBody className='cardBodySticky'>
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField='_id'
                          columns={this.state.TransferShippingListColumns}
                          data={completed_transfers.length !== 0 ? completed_transfers : transfers_shipping}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider keyField='_id' columns={this.state.TransferShippingListColumns} data={completed_transfers.length !== 0 ? completed_transfers : transfers_shipping} search>
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <Row className='mb-2'>
                                    <Col md='2' sm='12' className='d-flex'>
                                      <div className='search-box ms-2 mb-2 me-5 d-inline-block '>
                                        <div className='position-relative'>
                                          <SearchBar {...toolkitprops.searchProps} />
                                          <i className='bx bx-search-alt search-icon' />
                                        </div>
                                      </div>
                                    </Col>
                                    <Col md='4'>
                                      <AvForm className='d-flex' id='filter-date-form' onValidSubmit={this.handleFilterDataSubmit}>
                                        <FormGroup className='me-1'>
                                          <AvField type='select' name='status_type' style={{ width: 'auto' }} className='form-select fw-bold fs-5 trfilter '>
                                            <option value='' className='fw-bold fs-5 '>
                                              Select status
                                            </option>
                                            <option value='cd' className='fw-bold fs-5 '>
                                              Completed
                                            </option>
                                          </AvField>
                                        </FormGroup>
                                        <FormGroup className='pe-2'>
                                          <InputMask mask='99/99/9999' value={startDate} name='startDate' onChange={this.onChangeValue} className='form-control input-mask prfilter fw-bold fs-5' />
                                        </FormGroup>
                                        <FormGroup className='pe-2'>
                                          <InputMask mask='99/99/9999' value={endDate} name='endDate' onChange={this.onChangeValue} className='form-control input-mask prfilter fw-bold fs-5' />
                                        </FormGroup>
                                        <FormGroup className='me-1'>
                                          <button className='btn btn-success save-user' id='dblclick'>
                                            Filter
                                          </button>
                                        </FormGroup>
                                        <FormGroup className=''>
                                          <button type='reset' onClick={this.resetFilterData} className='btn btn-primary save-user'>
                                            Resets
                                          </button>
                                        </FormGroup>
                                      </AvForm>
                                    </Col>
                                  </Row>
                                  <Modal size='xl' isOpen={modalAssignBox} className={this.props.className} toggle={this.toggleNewAssignBoxModal} backdrop='static' keyboard={false}>
                                    <ModalHeader tag='h4' toggle={this.toggleNewAssignBoxModal}>
                                      Assign Box
                                    </ModalHeader>
                                    <ModalBody>
                                      {error && Array.isArray(error) ? (
                                        <Alert color='danger'>
                                          <ul className='mb-0'>
                                            {error.map((errMsg, index) => (
                                              <li key={index}>{errMsg}</li>
                                            ))}
                                          </ul>
                                        </Alert>
                                      ) : error ? (
                                        <Alert color='danger'>{error}</Alert>
                                      ) : null}
                                      <AvForm
                                        onValidSubmit={(event, values) => {
                                          setTimeout(() => {
                                            const { error } = this.props; // ✅ Ensures state has updated
                                            this.handleNewTransferShippingSubmit(event, values, error);
                                          }, 0); // ✅ Executes after React updates state
                                        }}
                                      >
                                        <Row>
                                          {this.state.newInputFields.map((field, index) => (
                                            <React.Fragment key={index}>
                                              <Col md={4}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    type='select'
                                                    name={`nomenclature${index}`}
                                                    className='form-select'
                                                    label='Nomenclature'
                                                    value={field.nomenclature}
                                                    disabled={field.submitted}
                                                    onChange={(e) => this.handleNomenclatureChange(index, e)}
                                                  >
                                                    <option>Choose</option>
                                                    {this.state.invNo &&
                                                      (() => {
                                                        // Helper: Sum quantities for each nomenclatureCode in boxNo
                                                        const totalQtyMap = this.state.invNo.boxNo.reduce((acc, curr) => {
                                                          const code = curr.nomenclatureCode;
                                                          const qty = Number(curr.quantity) || 0;
                                                          acc[code] = (acc[code] || 0) + qty;
                                                          return acc;
                                                        }, {});

                                                        // Helper: Sum selected quantities for each nomenclatureCode in selectedBoxs
                                                        const selectedQtyMap =
                                                          this.state.invNo.selectedBoxs?.reduce((acc, curr) => {
                                                            const code = curr.nomenclatureCode;
                                                            const qty = Number(curr.quantity) || 0;
                                                            acc[code] = (acc[code] || 0) + qty;
                                                            return acc;
                                                          }, {}) || {};

                                                        // Render distinct options
                                                        const uniqueOptions = Array.from(new Map(this.state.invNo.boxNo.map((inv) => [inv.nomenclatureCode, inv])).values());

                                                        return uniqueOptions.map((inv) => {
                                                          const code = inv.nomenclatureCode;
                                                          const totalQty = totalQtyMap[code] || 0;
                                                          const selectedQty = selectedQtyMap[code] || 0;
                                                          const isFullySelected = selectedQty >= totalQty;

                                                          return (
                                                            <option
                                                              key={code}
                                                              value={`${inv.nomenclature}||${code}`}
                                                              // disabled={isFullySelected}
                                                              style={{
                                                                color: isFullySelected ? 'grey' : 'inherit'
                                                              }}
                                                            >
                                                              {isFullySelected ? `🔁 (${selectedQty}/${totalQty}) ` : `(${selectedQty}/${totalQty}) `}
                                                              {inv.nomenclature}/{code}
                                                            </option>
                                                          );
                                                        });
                                                      })()}
                                                  </AvField>
                                                </FormGroup>
                                              </Col>
                                              <Col md={3}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    type='select'
                                                    name={`invoice${index}`}
                                                    className='form-select'
                                                    label='Invoice No'
                                                    value={field.invoice}
                                                    disabled={field.submitted}
                                                    onChange={(e) => this.handleInputChange(index, 'invoice', e.target.value)}
                                                  >
                                                    <option>Choose</option>
                                                    {Array.from(new Set(field.invoiceOptions)).map((invoice, idx) => (
                                                      <option key={idx} value={invoice}>
                                                        {invoice}
                                                      </option>
                                                    ))}
                                                  </AvField>
                                                </FormGroup>
                                              </Col>
                                              <Col md={2}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    name={`box${index}`}
                                                    label='Box No'
                                                    type='text'
                                                    value={field.box}
                                                    disabled={field.submitted}
                                                    onChange={(e) => this.handleInputChange(index, 'box', e.target.value)}
                                                    autoComplete='off'
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md={2}>
                                                <FormGroup className='mb-3'>
                                                  <AvField
                                                    name={`quantity${index}`}
                                                    label='Quantity'
                                                    type='text'
                                                    value={field.quantity}
                                                    onChange={(e) => this.handleInputChange(index, 'quantity', e.target.value)}
                                                    autoComplete='off'
                                                    disabled={field.submitted}
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md={1} className='d-flex align-items-center mt-2 justify-content-center' style={{ gap: '15px' }}>
                                                <Check
                                                  onClick={() => !field.submitted && this.handleSubmitSingleRow(index)}
                                                  color={field.submitted ? 'green' : '#28a745'}
                                                  title='Submit row'
                                                  size={32}
                                                  style={{
                                                    cursor: field.submitted ? 'default' : 'pointer',
                                                    opacity: field.submitted ? 0.5 : 1
                                                  }}
                                                />
                                                <Trash2
                                                  size={30}
                                                  onClick={() => !field.submitted && this.removeInputField(index)}
                                                  color='#f25621'
                                                  style={{
                                                    cursor: field.submitted ? 'not-allowed' : 'pointer',
                                                    opacity: field.submitted ? 0.5 : 1
                                                  }}
                                                />
                                              </Col>
                                            </React.Fragment>
                                          ))}
                                        </Row>
                                        <Row>
                                          <Col>
                                            <div className='text-end'>
                                              <button type='button' className='btn btn-primary' onClick={this.addInputField}>
                                                Add New Row
                                              </button>
                                              <button type='submit' className='btn btn-success save-user ms-2'>
                                                Assign box
                                              </button>
                                            </div>
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </ModalBody>
                                  </Modal>
                                  <Row id='table-section'>
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={'table align-middle '}
                                      headerClasses='header-class is-sticky-hdr'
                                      id='tableScroll'
                                      filter={filterFactory()}
                                      selectRow={selectRow}
                                      noDataIndication={this.indication}
                                      rowClasses={this.rowClasses}
                                      // striped={true}
                                      responsive
                                      cellEdit={cellEditFactory({
                                        mode: 'click',
                                        blurToSave: true,
                                        afterSaveCell: this.afterSaveCell
                                      })}
                                    />

                                    <div className={selectedRows.length === 0 ? 'action_row hidden' : 'action_row transfer_priority'}>
                                      <AvForm onValidSubmit={this.handleBulkUpdateStatus}>
                                        <AvField type='select' name='action' className='form-select' value={this.state.action || ''}>
                                          <option value='SELECT ACTION'>SELECT ACTION</option>
                                          <option value='complete'>Complete</option>
                                        </AvField>
                                        <button className='btn btn-success save-user'> APPLY </button>
                                      </AvForm>
                                      {/* <div style={{ marginTop: '20px', fontWeight: 'bold' }}>
                                        Total Quantity: {totalQuantity} | Total Quantity Left: {totalQuantityLeft}
                                      </div> */}
                                    </div>
                                  </Row>
                                  {this.state.alert}
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

TransferShippingList.propTypes = {
  transfers_shipping: PropTypes.array,
  completed_transfers: PropTypes.array,
  transfers_moscow_data: PropTypes.array,
  onGetTransferShipping: PropTypes.func,
  onGetCompletedTransfer: PropTypes.func,
  onDeleteTransferShipping: PropTypes.func,
  onUpdateTransferMoscowData: PropTypes.func
};

const mapStateToProps = ({ transfers }) => ({
  transfers_shipping: transfers.transfers_shipping,
  completed_transfers: transfers.completed_transfers,
  loading: transfers.loading,
  error: transfers.error
});

const mapDispatchToProps = (dispatch) => ({
  onGetTransferShipping: () => dispatch(getTransfersShipping()),
  onGetCompletedTransfer: (transfers) => dispatch(getCompletedTransfers(transfers)),
  onUpdateTransferMoscowData: (transfers) => dispatch(updateTransferMoscowData(transfers)),
  onDeleteTransferShipping: (transfers) => dispatch(deleteTransferShipping(transfers))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TransferShippingList));
